
import React from "react";
import { Button, ButtonProps } from "@/components/ui/button";
import { Table2 } from "lucide-react";
import { DataSource } from "@/components/data-tables/DataTables";

interface DataLinkButtonProps extends ButtonProps {
  dataSource: DataSource;
  onViewData: (dataSource: DataSource) => void;
  label?: string;
}

const DataLinkButton: React.FC<DataLinkButtonProps> = ({ 
  dataSource,
  onViewData,
  label = "View Data Tables", 
  ...props 
}) => {
  return (
    <Button
      variant="outline"
      size="sm"
      className="ml-auto flex items-center gap-1"
      onClick={() => onViewData(dataSource)}
      {...props}
    >
      <Table2 className="h-4 w-4 mr-1" /> {label}
    </Button>
  );
};

export default DataLinkButton;
